/**
 * 计算一个列表
 * @param list 源列表
 * @param pathCallback 计算path的回调函数
 * @returns {*[]} 返回计算后的列表
 */
export function calcList(list,pathCallback){
    const calc = []
    if(!list || !list.length) return calc
    for(let item of list) calc.push({...item,path:pathCallback(item)})
    return calc
}

/**
 * 计算关联历史名人
 * @param list
 * @returns {*[]}
 */
export function calcRelationCelebrity(list){
    return calcList(list,(item) => `/personage/detail/${item.id}`)
}

/**
 * 计算 历史名人 名人书籍
 * @param list
 */
export function calcPersonageBook(list){
    return calcList(list,(item) => `/personage/r/book/${item.id}`)
}

/**
 * 计算 富文本 列表
 * @param list
 */
export function calcHtml(list){
    return calcList(list,(item) => `/r/article/${item.id}`)
}

/**
 * 计算 富文本 列表
 * @param list
 */
export function calcVideo(list){
    return calcList(list,(item) => `/r/video/${item.id}`)
}

/**
 * 计算 富文本 列表
 * @param list
 */
export function calcImg(list){
    return calcList(list,(item) => `/r/img/${item.id}`)
}

/**
 * 计算 PDF 列表
 * @param list
 */
export function calcBook(list){
    return calcList(list,(item) => `/r/book/${item.id}`)
}
